import { Link } from "react-router-dom";
import { styled } from "@glitz/react";
import { spacing, black, white, fontSize, fontWeight, lightGrey } from "../theme";
import { FaFacebook, FaInstagram, FaSpotify } from "react-icons/fa6";
import NewsletterSignup from "./NewsletterSignup";

const base = process.env.PUBLIC_URL || "";
const PAYMENT_LOGOS = [
  { src: `${base}/logo/visa_logo.svg`, alt: "Visa" },
  { src: `${base}/logo/mastercard_logo.svg`, alt: "Mastercard" },
  { src: `${base}/logo/amex_logo.svg`, alt: "American Express" },
  { src: `${base}/logo/klarna_logo.png`, alt: "Klarna" },
  { src: `${base}/logo/swish_logo.svg`, alt: "Swish" },
];

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterItem>Fri frakt från 999kr</FooterItem>
      <Link
        to="/villkor"
        style={{
          color: white,
          fontSize: fontSize.s,
          textDecoration: "underline",
        }}
      >
        Köpvillkor, retur &amp; integritet
      </Link>
      <SocialLinkWrapper>
        <IconWrapper
          href="https://www.instagram.com/trirebels/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram />
        </IconWrapper>
        <IconWrapper
          href="https://www.facebook.com/trirebels/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebook />
        </IconWrapper>
        <IconWrapper
          href="https://open.spotify.com/user/robin_eriksson86/playlist/7fCFa5kmS0MXpHxB6S2OG9?si=kcuiJMFXQuG9vkSOjdYn2g"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaSpotify />
        </IconWrapper>
      </SocialLinkWrapper>
      <PaymentElementWrapper>
        {PAYMENT_LOGOS.map(({ src, alt }) => (
          <PaymentChip key={alt}>
            <PaymentLogo src={src} alt={alt} />
          </PaymentChip>
        ))}
      </PaymentElementWrapper>
      <NewsletterSignup />
    </FooterWrapper>
  );
};

const FooterWrapper = styled.footer({
  width: "100%",
  minHeight: spacing.xxxxl,
  paddingTop: spacing.xxl,
  paddingBottom: spacing.xxl,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: spacing.m,
  flexDirection: "column",
  backgroundColor: black,

});

const PaymentElementWrapper = styled.div({
  padding: { x: spacing.m, y: spacing.s },
  borderRadius: "9999px",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center",
  gap: spacing.s,
});

const PaymentChip = styled.div({
  backgroundColor: lightGrey,
  borderRadius: "9999px",
  padding: { x: spacing.m, y: spacing.xs },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const PaymentLogo = styled.img({
  height: "24px",
  width: "auto",
  maxWidth: "48px",
  objectFit: "contain",
});

const FooterItem = styled.div({
  color: white,
  fontSize: fontSize.m,
  fontWeight: fontWeight.bold,
});


const SocialLinkWrapper = styled.div({
  display: "flex",
  gap: spacing.m,
  fontSize: fontSize.xxl,
});

const IconWrapper = styled.a({
  cursor: "pointer",
  color: white,
});

export default Footer;
